module.exports = __webpack_public_path__ + "static/media/6.067ff599.jpg";